import { Data } from '@generated/Foundation.GMI.model';
import { ActionItem, ActionType } from '../ActionToolbar';
import { getEnumValue } from 'lib/utils/sitecore/enum';

export type ActionToolBarSettings = {
  fields?: {
    actionToolBarButtons?: Data.Content.ActionToolBarButton[];
  };
  variant?: string;
};

export function getActionToolbarButtons(
  actionToolBarButtons?: Data.Content.ActionToolBarButton[]
): ActionItem[] {
  if (!actionToolBarButtons) {
    return [];
  }

  return actionToolBarButtons?.map((button: Data.Content.ActionToolBarButton) => {
    // Check if this is a ShareActionToolBarButton (which has actionButtons field)
    const shareButton = button as Data.Content.ShareActionToolBarButton;
    const subActionsItems = shareButton.fields?.actionButtons?.map((subAction) => {
      const actionButton = subAction as Data.Content.ActionToolBarButton;
      return {
        label: actionButton.fields?.label?.value,
        type: getEnumValue<ActionType>(actionButton.fields?.actionType),
        eventPositionSuffix: actionButton.fields?.eventPositionSuffix?.value,
      };
    });

    return {
      label: button.fields?.label?.value,
      type: getEnumValue<ActionType>(button.fields?.actionType),
      eventPositionSuffix: button.fields?.eventPositionSuffix?.value,
      actionButtons: subActionsItems,
    };
  });
}
